<template>
  <div class="Componycontainer" id="bg">
    <my-header></my-header>  
    <!-- 返回顶部 -->
    <div class="backTop hide">
      <img @click="backTop" src="../assets/img/fanhuidingbu.png">
    </div>
    <div class="product">
      <!-- 产品服务顶部 -->
      <div class="banner">
        <img src="../assets/img/dingbudatu.png" alt="">
        <div>
          <p class="p1">产品服务</p>
          <p class="p2">PRODUCT SERVICE</p>
        </div>
      </div>
      <div class="center">
        <!-- 第一层 -->
        <div class="first_center" id="data">
          <div class="first_title" >
            <div>
              <p class="p1">DATA PRODUCT SERVICE</p>
              <p class="p2">数据产品服务</p>
            </div>
          </div>  
          <div style="background:#f7f7f7;display:flex;" >
            <div class="product_data" style="display:flex; padding:3% 20%; width:100%;height:100%;">
              <div style="padding-right:5% ;width:50%">
                <p class="p3">技术文档撰写和插图设计</p>
                <p class="p4">包括但不限于汽车维修手册、电路图册、诊断手册、 零部件手册、用户手册及技术培训课件等设计开发。</p>
              </div>
              <div style="width:50%">
                <img src="../assets/img/shujuchanpinfuwupeitu.png">
              </div>
            </div>
          </div>
          <div>
            <div style="display:flex;padding:3% 20%;width:100%;height:100%">
              <div style="width:50%">
                <img src="../assets/img/shipinzhizuopeitu.png">
              </div>
              <div style="padding-left:5%;width:50%">
                <p class="p3">AR/动画视频制作</p>
                <p class="p4">包括但不限于AR交互动画、维修操作视频、车主指南视频等设计制作。</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 第二层 -->
        <div class="second_center" id="software">
          <div class="second_title">
            <div>
              <p class="p1">SOFTWARE PRODUCT SERVICE</p>
              <p class="p2">软件产品服务</p>
            </div>
          </div>
          <div style="background:#f7f7f7;display:flex;width:100%;height:100%">
            <div style="display:flex;padding:3% 20%;">
              <div style="padding-right:5%;width:50%">
                <p class="p4">包括但不限于电子配件目录管理系统 (EPC) 、交互式电路图管理系统 (ICMS) 、维修技术信息发布系统 (MTDS) 、用户手册管理系统 (OMS) 、专家诊断系统 (EDS) 、APP及微信小程序等定制化开发。</p>
              </div>
              <div style="width:50%">
                <img src="../assets/img/ruanjianchanpinfuwu.png">
              </div>
            </div>
          </div>
        </div>
        <!-- 第三层 -->
        <div class="third_center" id="equipment">
          <div class="third_title">
            <div>
              <p class="p1">EQUIPMENT PRODUCT CUSTOMIZED SERVICE</p>
              <p class="p2">设备产品定制服务</p>
            </div>
          </div>
          <div style="display:flex;padding:3% 20%;width:100%;height:100%">
            <div style="width:50%">
              <img src="../assets/img/shebeichanpindi9ngzhifuwu.png">
            </div>
            <div style="padding-left:5%;width:50%">
              <p class="p4">为车企提供专业的设备设计、研发及量产服务，包括但不限于汽车维修专用工具(SST)、培训教学用具设备、精品件等定制服务。</p>
            </div> 
          </div>
        </div>   
      </div>
      <div><my-footer></my-footer></div> 
    </div>
  </div> 
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from "@/components/Headers.vue";
  import myFooter from "@/components/Footers.vue";
  export default {
    data(){
      return{
       i:0,
      }
    },
    mounted(){
      // 监听滚动条的滚动长度
      window.addEventListener('scroll', this.scrollToTop)
      $('ul :nth-child(2)').removeClass('bannerOne')
      $('ul :nth-child(2)').removeClass('bannerTwo')
      var hash = window.location.hash;
      var index = hash.lastIndexOf("#");
      if(index !=-1){
        var id = hash.substring(index + 1,hash.length+1)
        var div = document.getElementById(id);
        if(div){
          $('html,body').scrollTop($(div).offset().top-$('.third_title').height())
        }
      }
    },
    methods:{
      //监听鼠标滚动的长度   
      scrollToTop(){
        $('ul :nth-child(2)').removeClass('bannerOne')
        $('ul :nth-child(2)').removeClass('bannerTwo')
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 滚动的长度大于顶部图片时，顶部导航加背景
        if(scrollTop>$('.banner').height()-50){
          $('header').removeClass('goheader')
          $('header').addClass('headerbg')
          $('.img1').addClass('hide')
          $('.img2.hide').removeClass('hide')
          $('.backTop').removeClass('hide')
        }else{
          $('header').removeClass('headerbg')
          $('.img1').removeClass('hide')
          $('.img2').addClass('hide')
          $('.backTop').addClass('hide')
        }
      },
      // 点击以300ms的速度返回顶部
      backTop(){
        $('body,html').animate({scrollTop:0},300)
      }
    },
    components:{
      myHeader,
      myFooter,
    }
  }
</script>
<style scoped lang = 'scss'>
  @import '@/lib/reset.scss';
  *{margin:0;padding:0}
  /* 返回顶部 */
  .backTop{
    position:fixed;
    right: 2%;
    bottom:3%;
    z-index:2;
  }
  .backTop img{
    width:50px;
  }
  /* 顶部 */
  .hide{display: none}
  .product .banner{
    width:100%;
    height:auto;
    position: relative; 
    overflow: hidden;
  }
  .product .banner img{
    position: relative; 
    top: -2%;
    width:100%;
  }
  .product .banner div{
    position: absolute;
    left:44%;
    top:41%;
    text-align: left;
  }
  .product .banner div .p1{
 
    font-size: 65px;
    color: #fff;
    line-height: 65px;
  }
  .product .banner div .p2{
 
    font-size: 27px;
    color: #fff;
  }
  /* 层级标题 */
  .first_title,.second_title,.third_title{margin:2% 20%}
  .first_title .p1,.second_title .p1,.third_title .p1{

    font-size:22px;
    color:#888;
  }
  .first_title .p2,.second_title .p2,.third_title .p2{

    font-size:34px;
    color:#003e8d;
  }
  .first_title,.second_title,.third_title{
    position:relative;
    border-bottom: 1px solid #ccc;
    padding-bottom: 1%;
    margin-bottom: 3%;
  }
  .first_title div,.second_title div,.third_title div{
    position: absolute;
    top:5%;
    left: 2%; 
  }
  .first_title p,.second_title p,.third_title p{
    line-height:1.2;
  }
  .first_title::before,.second_title::before,.third_title::before{
    content: url('../assets/img/lanseshuxiantiao.png');
  }
  .first_center img,.second_center img,.third_center img{
    width: 98%;
  }
  .first_center .p3{
    font-size: 25px;
    color:#555;
    line-height: 50px;
  }
  .first_center .p4,.second_center .p4,.third_center .p4{
    font-size: 22px;
    color:#666666;
    text-indent:2em;
    line-height:40px;
  }
  @media screen and (max-width:1440px) and (min-width:1366px){
    .first_title p,.second_title p,.third_title p{
      line-height:1.3;
    }
    .first_title .p2,.second_title .p2,.third_title .p2{
      font-size:32px;
    }
    .first_center .p3{
      font-size: 24px;
      line-height:40px;
    }
    .first_title,.second_title,.third_title{
      padding-bottom:0.8%;
    }
    .product .banner div{
      position:absolute;
      top:36%;
      left:41%;
      text-align: left;
    }
    .product .banner div .p1{
      font-size:55px;
      line-height: 60px;
    }
    .product .banner div .p2{
      font-size: 23px;
    }
    /* 返回顶部 */
    .backTop{
      position:fixed;
      top:93%;
      right: 2%;
      z-index:2;
    }
    .backTop img{
      width: 45px;
    }
    .first_center .p4,.second_center .p4,.third_center .p4{
      font-size: 21px;
      line-height:35px;
    }
  }
  @media screen and (max-width:1366px) and (min-width:1280px){
    .product .banner div{
      position: absolute;
      top:33%;
      left:41%;
      text-align: left;
    }
    .product .banner div .p1{
      font-size:53px;
      line-height: 57px;
    }
    .product .banner div .p2{
      font-size: 22px;
    }
    .first_center img,.second_center img,.third_center img{
      width: 90%;
    }
    .first_center .p4,.second_center .p4,.third_center .p4{
      font-size: 20px;
      line-height:30px;
    }
    .first_title .p1,.second_title .p1,.third_title .p1{
      font-size:21px;
    }
    .first_title .p2,.second_title .p2,.third_title .p2{
      font-size:30px;
    }
    .first_center .p3{
      font-size: 23px;
      line-height:35px;
    }
    .first_title,.second_title,.third_title{
      padding-bottom:0.7%;
    }
    /* 返回顶部 */
    .backTop{
      position:fixed;
      top:92%;
      right: 2%;
      z-index:2;
    }
    .backTop img{
      width:40px;
    }
  }
  @media screen and (max-width:1280px) and (min-width:1024px){
    .product .banner div{
      position: absolute;
      top:37%;
      left:41%;
      text-align: left;
    }
    .product .banner div .p1{
      font-size:50px;
      line-height: 60px;
    }
    .product .banner div .p2{
      font-size: 22px;
    }
    .first_title p,.second_title p,.third_title p{
      line-height:1.3;
    }
    .first_center img,.second_center img,.third_center img{
      width: 90%;
    }
    .first_center .p4,.second_center .p4,.third_center .p4{
      font-size:19px;
      line-height:30px;
    }
    .first_title .p1,.second_title .p1,.third_title .p1{
      font-size:20px;
    }
    .first_title .p2,.second_title .p2,.third_title .p2{
      font-size:28px;
    }
    .first_center .p3{
      font-size: 23px;
      line-height:35px;
    }
    .first_title,.second_title,.third_title{
      padding-bottom:0.5%;
    }
    /* 返回顶部 */
    .backTop{
      position:fixed;
      top:92%;
      right:2%;
      z-index:2;
    }
    .backTop img{
      width:40px;
    }
    .first_center .p3{
      font-size: 23px;
      color:#555;
      line-height:40px;
    }
  }
  @media screen and (max-width:1024px)and (min-width:650px){
    /*  */
    .product .banner div{
      position: absolute;
      top:34%;
      left:39%;
      text-align: left;
    }
    .product .banner div .p1{
      font-size:42px;
      line-height: 40px;
    }
    .product .banner div .p2{
      font-size: 17px;
      line-height: 40px;
    }
     .first_title p,.second_title p,.third_title p{
      line-height:1.3;
    }
    .first_center img,.second_center img,.third_center img{
      width: 100%;
    }
    .first_center .p4,.second_center .p4,.third_center .p4{
      font-size:18px;
      line-height:27px;
    }
    .first_title .p1,.second_title .p1,.third_title .p1{
      font-size:20px;
    }
    .first_title .p2,.second_title .p2,.third_title .p2{
      font-size:28px;
    }
    .first_center .p3{
      font-size: 22px;
      line-height:35px;
    }
    .first_title,.second_title,.third_title{
      padding-bottom:0.5%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Product.vue